import { render, staticRenderFns } from "./ArticulosOficina.vue?vue&type=template&id=011df226&"
import script from "./ArticulosOficina.vue?vue&type=script&lang=js&"
export * from "./ArticulosOficina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports